/**
 * Whether the rail is in edit mode: the only state in which sections are
 * created (＋ New section, *Add section above*, empty-section drop boxes).
 * Off by default and never persisted — sections are added rarely, so the rail's
 * everyday face carries no section-making chrome. Moving rows and sections, and
 * the header menus, work in either state.
 */
import { create } from 'zustand';

interface RailEditState {
  editing: boolean;
  setEditing: (editing: boolean) => void;
}

/** Shared by the header's Edit / Done toggle and the rail. */
export const useRailEditStore = create<RailEditState>(set => ({
  editing: false,
  setEditing: editing => set({ editing }),
}));
